/* eslint-disable react/prop-types */
import React, { useState, memo } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Checkbox from 'housecall-ui/dist/DesignSystem/Inputs/Checkboxes/Checkbox';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Tooltip from 'housecall-ui/dist/DesignSystem/DataDisplay/Tooltips/Tooltip';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import RadioButtonUncheckedIcon from 'housecall-ui/dist/IconsAndImages/Icons/RadioButtonUnchecked';
import EditIcon from 'housecall-ui/dist/IconsAndImages/Icons/Edit';
import CheckIcon from 'housecall-ui/dist/IconsAndImages/Icons/Check';
import DeleteIcon from 'housecall-ui/dist/IconsAndImages/Icons/Delete';
import TruncateText from 'housecall-ui/dist/utils/TruncateText';
import { isPresent } from 'utils/isPresent';
import { TASK_SELECTED, completeTask, deleteTask } from './Redux/Actions';

const styles = (theme) => ({
  taskItem: {
    padding: 10,
  },
  editButton: {
    color: theme.palette.secondary.light,
  },
  deleteButton: {
    color: theme.palette.secondary.light,
  },
  bodyText: {
    color: theme.palette.secondary.light,
  },
});

const Task = ({ classes, task }) => {
  const [showEditDeleteButton, setShowEditDeleteButton] = useState(false);

  const dispatch = useDispatch();

  const handleDeleteTask = () => dispatch(deleteTask(task.id));
  const handleSelectTask = () => dispatch({ type: TASK_SELECTED, task });
  const handleChange = (event) =>
    dispatch(completeTask(task.id, event.target.checked));

  const getActionButton = () => {
    if (task.completed) {
      return (
        <IconButton
          onClick={handleDeleteTask}
          data-testid='delete-task-on-list-button'
        >
          <DeleteIcon classes={{ colorPrimary: classes.deleteButton }} />
        </IconButton>
      );
    }
    return (
      <IconButton
        onClick={handleSelectTask}
        data-testid='edit-task-on-list-button'
      >
        <EditIcon classes={{ colorPrimary: classes.editButton }} />
      </IconButton>
    );
  };

  const tooltip = task.completed ? 'mark incomplete' : 'mark complete';

  let actionButton = null;

  if (showEditDeleteButton) {
    actionButton = getActionButton();
  }

  const handleShowEditDeleteButton = () => setShowEditDeleteButton(true);
  const handleHideEditDeleteButton = () => setShowEditDeleteButton(false);

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justify="flex-start"
        className={classes.taskItem}
        onMouseOver={handleShowEditDeleteButton}
        onMouseLeave={handleHideEditDeleteButton}
      >
        <Grid item xs={2}>
          <Tooltip id="tooltip-fab" title={tooltip}>
            <Checkbox
              color="primary"
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckIcon />}
              checked={!!task.completed}
              onChange={handleChange}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" noWrap>
            {task.title}
          </Typography>
          <Typography variant="body1" className={classes.bodyText}>
            <TruncateText>{task.description}</TruncateText>
          </Typography>
          <Typography variant="body1" className={classes.bodyText} noWrap>
            {isPresent(task.due)
              ? moment(task.due).format('dddd, MMMM Do YYYY')
              : null}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          {actionButton}
        </Grid>
      </Grid>
      <Divider />
    </div>
  );
};

export default withStyles(styles)(memo(Task));
